// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ajoute un espace entre les colonnes */
.border-end {
  border-right: 1px solid #ddd;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.scrollable {
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/Components/QuizLesson/QuizLesson.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* Ajoute un espace entre les colonnes */\n.border-end {\n  border-right: 1px solid #ddd;\n}\n\n.ps-4 {\n  padding-left: 1.5rem !important;\n}\n\n.pe-4 {\n  padding-right: 1.5rem !important;\n}\n\n.scrollable {\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
